import React from "react";

/* eslint-disable max-len */
function RecIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={100} height={80} viewBox="0 0 100 80">
            <defs>
                <style>{".c{fill:#4b4f59}"}</style>
            </defs>
            <path
                d="M74.7 28.1L100 61.7V5a4.951 4.951 0 00-5-5H5a4.951 4.951 0 00-5 5v70a4.951 4.951 0 005 5h55.3L39.5 52.9z"
                fill="#16adc1"
                transform="translate(2951 1162) translate(-2951 -1162)"
            />
            <path
                d="M100 61.7L74.7 28.1 39.5 52.9 60.3 80H95a4.951 4.951 0 005-5z"
                fill="#179faa"
                transform="translate(2951 1162) translate(-2951 -1162)"
            />
            <g>
                <path
                    className="c"
                    d="M74.8 29v22.7a1.88 1.88 0 01-1.8 1.9H40.6a1.817 1.817 0 01-1.8-1.9V29a1.88 1.88 0 011.8-1.9H73a1.88 1.88 0 011.8 1.9zM35.8 35.7V45a2.088 2.088 0 01-.8 1.6l-9 6a.97.97 0 01-1.5-.8V28.9a.954.954 0 011.5-.8l9 6a1.943 1.943 0 01.8 1.6z"
                    transform="translate(2951 1162) translate(-2951 -1162)"
                />
            </g>
        </svg>
    );
}

export default RecIcon;
